import React, { SVGProps } from 'react';

const FavoritesIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 13 12"
			fill="none"
			width="100%"
			height="100%"
			{...props}
		>
			<path
				d="M13 3.53072C12.9846 0.155725 8.56422 -1.07141 6.78935 1.73504C6.65335 1.94962 6.33766 1.94962 6.20163 1.73499C5.60521 0.793852 4.55387 0.168958 3.35635 0.168958C1.40537 0.163751 0.000533339 1.82706 0.000533339 3.78466H0C0 7.98343 4.98016 11.0556 6.22056 11.7557C6.39552 11.8545 6.60888 11.8564 6.78562 11.7608C8.0448 11.0802 13 8.06008 13 3.53072Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default FavoritesIcon;
